export const COMMUNITY_INSIGHTS_CHARTS_COLOR = [
  { bg: "bg-primary-600", color: "#1641B9" },
  { bg: "bg-primary-300", color: "#8eabfb" },
  { bg: "bg-primary-100", color: "#c7d5fd" },
  { bg: "bg-primary-50", color: "#e8eefe" },
  { bg: "bg-primary-900", color: "#091A4A" },
  { bg: "bg-primary-500", color: "#1D56F7" },
  { bg: "bg-primary-200", color: "#A2BAFC" },
  { bg: "bg-primary-800", color: "#0c2263" },
  { bg: "bg-primary-400", color: "#5680f9" },
  { bg: "bg-primary-700", color: "#0f2b7b" },
];

export const KEY_TO_NAME_MAP: Record<string, string> = {
  HIGH: "CORE",
  MEDIUM: "ADJACENT",
  LOW: "EXPANSION",
};
